module["exports"] = [
  "გამზ.",
  "გამზირი",
  "ქ.",
  "ქუჩა",
  "ჩიხი",
  "ხეივანი"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/street_suffix.js
// module id = 1232
// module chunks = 0